import React, { Component } from "react";
import packageJson from "../../package.json";
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';

class TsHeader extends Component {
  render() {
    return (
      <div className="tsHeader">
        <div className='tsVersion'>V:{packageJson.version}</div>
        <img src='europavard_logo.png' alt='logo' />
        <div className='tsMenu'>
          <a href="./">
          {/* <a href="./#/home"> */}
            <MedicalInformationIcon />
          </a>
        </div>
      </div>
    );
  }
}
export default TsHeader;
